<div [class]="large? 'h-box rating-large' : 'h-box rating-small'">
  <ng-template *ngIf="interactive" ngFor let-item let-i="index" [ngForOf]="createRating()">
    <ion-icon *ngIf="item" name="star" (touchstart)="onStarSelected($event, i)" (click)="onStarSelected($event, i)" aria-label="Favorite"></ion-icon>
    <ion-icon *ngIf="!item" name="star-outline" (touchstart)="onStarSelected($event, i)" (click)="onStarSelected($event, i)" aria-label="Favorite"></ion-icon>
    <span *ngIf="item" name="star" (touchstart)="onStarSelected($event, i)" (click)="onStarSelected($event, i)"></span>
    <span *ngIf="!item" name="star-outline" (touchstart)="onStarSelected($event, i)" (click)="onStarSelected($event, i)"></span>
  </ng-template>
  <ng-template *ngIf="!interactive" ngFor let-item let-i="index" [ngForOf]="createRating()">
    <ion-icon *ngIf="item" name="star"></ion-icon>
    <ion-icon *ngIf="!item" name="star-outline"></ion-icon>
  </ng-template>
</div>
